import { LoaderCircle } from "lucide-react";

export const Loader = ({
  size = 40,
  
  className = "",
  loaderClass = "",
  isActive = false,
}) => {
  return (
    <>
      {isActive && (
        <div
          className={`${className} fixed left-0 top-0 w-full h-full z-50 bg-black/40 flex items-center justify-center`}
        >
          <div className="p-10 flex items-center justify-center bg-white gap-2 rounded-2xl ">
            <LoaderCircle
              size={size}
              className={`${loaderClass} animate-spin text-blue-600 `}
            />
            <div className="text-black">Please wait...</div>
          </div>
        </div>
      )}
    </>
  );
};
